'use strict'

import { gsap, ScrollTrigger } from 'tc-neos-animations'

const buildDesktopMenu = () => {
    gsap.registerPlugin(ScrollTrigger)

    const menuTrigger = document.querySelector('#main-header .menu-trigger')
    const megamenu = document.querySelector('#main-header .tc-website-megamenu')
    const menuClose = megamenu.querySelector('.menu-close .close-content')

    // initial state
    gsap.set(megamenu, { opacity: 0, pointerEvents: 'none' })

    const openMenu = () => {
        gsap.killTweensOf(megamenu)
        gsap.to(megamenu, {
            duration: 0.6,
            opacity: 1,
            pointerEvents: 'auto',
            ease: 'power2.out',
            onComplete: () => document.addEventListener('click', handleOutsideClick)
        })

        document.documentElement.classList.add('megamenu-opened');
    }

    const closeMenu = () => {
        gsap.killTweensOf(megamenu)
        gsap.to(megamenu, {
            duration: 0.5,
            opacity: 0,
            pointerEvents: 'none',
            ease: 'power2.in',
            onComplete: () => document.removeEventListener('click', handleOutsideClick)
        })

        document.documentElement.classList.remove('megamenu-opened');
    }

    const handleOutsideClick = (event) => {
        const isClickInside = megamenu.contains(event.target)
        const isTrigger = menuTrigger.contains(event.target)
        if (!isClickInside && !isTrigger) closeMenu()
    }

    menuTrigger.addEventListener('click', (e) => {
        e.stopPropagation()
        openMenu()
    })

    menuClose.addEventListener('click', (e) => {
        e.stopPropagation()
        closeMenu()
    })
}

export default { buildDesktopMenu }
